export const ROUTE_PATH = {
  common: {
    HOME: '/',
    LOGIN: '/login',
    FIND_PASSWORD: '/find-password',
    RESET_PASSWORD: '/reset-password',
    CHANGE_PASSWORD: '/change-password',
    TERMS: '/terms',
    PRIVACY_POLICY: '/privacy-policy',
    TERMS_OF_USE: '/terms-of-use',
    NOTICE: '/notice',
    NOTICE_REGISTER: '/notice/register',
    MYPAGE: '/mypage',
    MYPAGE_EDIT: '/mypage/edit',
    FORBIDDEN: '/forbidden',
  },
  professor: {
    STUDENT: '/student',
    CLINICAL_PRACTICE: '/clinical-practice',
    SCORE_MANAGEMENT: '/score-management',
    REGISTERED_ROUND: '/registered-round',
    STATISTICS: '/statistics',
  },
  student: {
    PATIENT: '/patient',
    PATIENT_REGISTER: '/patient/register',
    PATIENT_MANAGEMENT: '/patient-management',
    SCORE_REPORT: '/score-report',
    PRACTICE_CHART: '/practice-chart',
    EVALUATION_CHART: '/evaluation-chart',
  },
  chart: {
    MEDICAL_HISTORY_CHART: '/medical-history-chart',
    DENTAL_HISTORY_CHART: '/dental-history-chart',
    METHODS_OF_ORAL_HYGIENE: '/methods-of-oral-hygiene-chart',
    VITAL_SIGN_CHART: '/vital-sign-chart',
    EXTRA_INTRA_ORAL_EXAMINATION_CHART: '/extra-intra-oral-examination-chart',
    ORAL_EXAMINATION_CHART: '/oral-examination-chart',
    ORAL_MICROBIAL_EXAMINATION_CHART: '/oral-microbial-examination-chart',
    PREVENTIVE_DENTAL_TREATMENT_CHART: '/preventive-dental-treatment-chart',
    PERIODONTAL_EXAMINATION_CHART: '/periodontal-examination-chart',
    DSLR_CHART: '/dslr-chart',
    INTRA_ORAL_CAMERA_CHART: '/intra-oral-camera-chart',
    PLAQUE_CONTROL_RECORD_CHART: '/plaque-control-record-chart',
    STUDY_MODEL_CHART: '/study-model-chart',
    DH_IMPLEMENTATION_CHART: '/dh-implementation-chart',
    DH_DIAGNOSIS_PLAN_EVALUTAION_CHART: '/dh-diagnosis-plan-evaluation-chart',
    ORAL_HEALTH_EDUCATION_DATA_CHART: '/oral-health-education-data-chart',
  },
};
